import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-372ff11d"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "notice-preview-workspace"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "通知与待办验收", -1))
const _hoisted_3 = { class: "controls" }
const _hoisted_4 = { role: "status" }
const _hoisted_5 = { key: 0 }

import {ref,onBeforeUnmount,onMounted} from 'vue'
import request from '@/utils/request'

export default /*#__PURE__*/_defineComponent({
  __name: 'NotificationExperiencePreview',
  props: {
    admin: { type: Boolean }
  },
  setup(__props: any) {

const props = __props as {admin?:boolean};


const enabled=['127.0.0.1','localhost'].includes(location.hostname)&&new URLSearchParams(location.search).get('noticeExperience')==='1'
const rows=ref<any[]>([]),unread=ref(0),todos=ref(0),inbox=ref(false),sending=ref(false),busy=ref(false),readFails=ref(false),status=ref('请选择场景。平台／分店、客户／管理账号的数据分别保存。')
const width=Math.min(460,window.innerWidth-24)
const scenarios=[['shipment','多笔发货合并'],['quote',props.admin?'待报价提醒':'报价待确认'],['delivery','版型交付'],['security','安全提醒'],['aftersale','售后提醒'],['mixed','同时收到多类通知']]
const endpoint=()=> (props.admin?'system':'customer')+'/notificationPreview'
let disposed=false
async function load(){if(!enabled||disposed)return;try{const response=await request({url:endpoint(),method:'GET',quietNotification:true} as any);if(disposed)return;const data=response.data;rows.value=data.rows||[];unread.value=Number(data.unreadCount)||0;todos.value=Number(data.todoCount)||0;readFails.value=!!data.readFails}catch{if(!disposed)status.value='模拟服务读取失败，请刷新重试。'}}
async function start(scenario:string,restart=true){if(sending.value)return;sending.value=true;try{await request({url:endpoint(),method:'POST',data:{scenario},quietNotification:true} as any);await load();status.value=scenario==='shipment'&&props.admin?'管理端不重复弹客户发货通知。':scenario==='fail'?'已切换模拟网络状态。':scenario==='remoteConfirm'?'另一端已确认，当前弹窗将在轮询后撤下。':'场景已加载；按钮打开的是本次实际通知组件。';if(restart)reenter()}catch{status.value='场景加载失败，请重试。'}finally{sending.value=false}}
function reenter(){window.dispatchEvent(new CustomEvent('business-notice-preview-reset'))}
function toggleBusy(){busy.value=!busy.value;window.dispatchEvent(new CustomEvent('business-notice-preview-busy',{detail:busy.value}));status.value=busy.value?'填写／付款期间暂缓弹窗。':'操作结束，可以恢复提醒。'}
let timer:ReturnType<typeof setInterval>|undefined
onMounted(()=>{if(enabled){void load();timer=setInterval(()=>{void load()},1500)}})
onBeforeUnmount(()=>{disposed=true;if(timer)clearInterval(timer)})

return (_ctx: any,_cache: any) => {
  const _component_a_tag = _resolveComponent("a-tag")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_badge = _resolveComponent("a-badge")!
  const _component_a_empty = _resolveComponent("a-empty")!
  const _component_a_drawer = _resolveComponent("a-drawer")!

  return (_unref(enabled))
    ? (_openBlock(), _createElementBlock("section", _hoisted_1, [
        _hoisted_2,
        _createVNode(_component_a_tag, { color: "orange" }, {
          default: _withCtx(() => [
            _createTextVNode("实际通知组件 · 本地模拟业务事件")
          ]),
          _: 1
        }),
        _createElementVNode("p", null, "当前" + _toDisplayString(__props.admin?'管理账号':'客户账号') + "；消息确认存于本地模拟服务，刷新不丢失。不会执行真实发货、付款或退款。", 1),
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_a_badge, { count: unread.value }, {
            default: _withCtx(() => [
              _createVNode(_component_a_button, {
                onClick: _cache[0] || (_cache[0] = ($event: any) => (inbox.value=true))
              }, {
                default: _withCtx(() => [
                  _createTextVNode("消息中心")
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["count"]),
          _createVNode(_component_a_badge, { count: todos.value }, {
            default: _withCtx(() => [
              _createVNode(_component_a_button, {
                onClick: _cache[1] || (_cache[1] = ($event: any) => (inbox.value=true))
              }, {
                default: _withCtx(() => [
                  _createTextVNode("待办")
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["count"]),
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(scenarios, (item) => {
            return _createVNode(_component_a_button, {
              key: item[0],
              disabled: sending.value,
              onClick: ($event: any) => (start(item[0]))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(item[1]), 1)
              ]),
              _: 2
            }, 1032, ["disabled", "onClick"])
          }), 64)),
          _createVNode(_component_a_button, { onClick: toggleBusy }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(busy.value?'结束填写／付款':'模拟正在填写／付款'), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_a_button, {
            onClick: _cache[2] || (_cache[2] = ($event: any) => (start('fail',false)))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(readFails.value?'恢复确认网络':'模拟确认失败'), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_a_button, {
            onClick: _cache[3] || (_cache[3] = ($event: any) => (start('remoteConfirm',false)))
          }, {
            default: _withCtx(() => [
              _createTextVNode("模拟另一端确认")
            ]),
            _: 1
          }),
          _createVNode(_component_a_button, { onClick: reenter }, {
            default: _withCtx(() => [
              _createTextVNode("模拟下次进入")
            ]),
            _: 1
          }),
          _createVNode(_component_a_button, {
            onClick: _cache[4] || (_cache[4] = ($event: any) => (start('reset')))
          }, {
            default: _withCtx(() => [
              _createTextVNode("重置预览")
            ]),
            _: 1
          })
        ]),
        _createElementVNode("p", _hoisted_4, _toDisplayString(status.value), 1),
        _createVNode(_component_a_drawer, {
          visible: inbox.value,
          title: "消息与待办",
          width: _unref(width),
          onClose: _cache[5] || (_cache[5] = ($event: any) => (inbox.value=false))
        }, {
          default: _withCtx(() => [
            (!rows.value.length)
              ? (_openBlock(), _createBlock(_component_a_empty, {
                  key: 0,
                  description: "暂无消息"
                }))
              : _createCommentVNode("", true),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(rows.value, (row) => {
              return (_openBlock(), _createElementBlock("article", {
                key: row.id
              }, [
                _createVNode(_component_a_tag, null, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(row.readed?'已收到':'未读'), 1)
                  ]),
                  _: 2
                }, 1024),
                _createElementVNode("p", null, _toDisplayString(row.message), 1),
                (row.task)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_5, _toDisplayString(row.done?'业务已完成':'业务待处理；已收到不代表已完成'), 1))
                  : _createCommentVNode("", true)
              ]))
            }), 128))
          ]),
          _: 1
        }, 8, ["visible", "width"])
      ]))
    : _createCommentVNode("", true)
}
}

})